DJ.addBehavior('js-troubles-slider', '.js-troubles-slider', {
  attach: function(context, settings, behavior) {
    var holder = jQuery(context);
    var slider = holder.find('.slider');
    var controls = holder.find('.slider-controls')
    var content = slider.closest('.content');
    slider.slick({
      slidesToShow: content.length && content.width() < 1024 ? 3 : 4,
      slidesToScroll: 1,
      infinite: false,
      dots: true,
      responsive: [
        {
          breakpoint: 974,
          settings: {
            slidesToShow: 1,
          }
        }
      ],
      appendDots: controls.find('.slide-dots'),
      prevArrow: controls.find('.slide-prev'),
      nextArrow: controls.find('.slide-next')
    });
  },

  detach: function(context, settings) {}
});
